/*
 * Copyright (C) 2024 Jonathan Canevese - All Rights Reserved
 * This is copyrighted software
 * Unauthorized copying of this file, via any medium is strictly prohibited
 * Proprietary and confidential by Jonathan Canevese
 */

import { Client, Account, TablesDB, Storage, ID } from "appwrite";

const client = new Client()
  .setEndpoint("https://fra.cloud.appwrite.io/v1")
  .setProject("697e0d71002943c5f241");

const account = new Account(client);
const databases = new TablesDB(client);
const storage = new Storage(client);

console.log("Appwrite client initialized");

export { client, account, databases, storage, ID };
